import { render, staticRenderFns } from "./NewComics.vue?vue&type=template&id=39e2f887&scoped=true&"
import script from "./NewComics.vue?vue&type=script&lang=js&"
export * from "./NewComics.vue?vue&type=script&lang=js&"
import style0 from "./NewComics.vue?vue&type=style&index=0&id=39e2f887&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2f887",
  null
  
)

export default component.exports